import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'

interface Props {
  open: boolean
  closeDialog: () => void
  title: string
  content: React.ReactNode
  fullScreen: boolean
}

const ProductDetailDialog: React.FC<Props> = ({
  fullScreen,
  open,
  closeDialog,
  title,
  content
}) => {
  return (
    <Dialog maxWidth='lg' fullWidth fullScreen={fullScreen} open={open} onClose={closeDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  )
}

export default ProductDetailDialog
